export default __webpack_public_path__ + "static/media/319.15a96942.png";